
import React from "react";
import { Badge } from "@/components/ui/badge";

interface ChannelBadgeProps {
  channel: string;
}

export const ChannelBadge = ({ channel }: ChannelBadgeProps) => {
  switch (channel) {
    case 'email':
      return <Badge variant="secondary" className="text-xs py-0.5 px-2 bg-blue-50 text-blue-700">Email</Badge>;
    case 'whatsapp':
      return <Badge variant="secondary" className="text-xs py-0.5 px-2 bg-green-50 text-green-700">WhatsApp</Badge>;
    case 'sms':
      return <Badge variant="secondary" className="text-xs py-0.5 px-2 bg-purple-50 text-purple-700">SMS</Badge>;
    default:
      return null;
  }
};
